import { render, staticRenderFns } from "./rego-customer-residential-address.vue?vue&type=template&id=7711c58a&scoped=true&"
import script from "./rego-customer-residential-address.vue?vue&type=script&lang=js&"
export * from "./rego-customer-residential-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7711c58a",
  null
  
)

export default component.exports